import { COLORS } from "../../../constants";
import { StyledModal } from "../../_ui";
import { ModalButton, ModalContent, ModalTitle } from "./components";

const Modal = ({isOpen, title, content, btn1, btn2}: TQuizzModalProps) => {
  return (
    // @ts-ignore
    <StyledModal
      withPadding={false}
      isOpen={isOpen}
      onRequestClose={() => {}}
      overlay={true}
      withWrapper={true}
    >
      <div>
        <ModalTitle>{title}</ModalTitle>
        <ModalContent>{content}</ModalContent>

        <div style={{ display: "flex", justifyContent: "space-between", flexDirection: "row", padding: "0px 40px" }}>
          <ModalButton
            color={COLORS.SECONDARY}
            onClick={() => btn1.func()}
          >
            {btn1.label}
          </ModalButton>
          {btn2 && <ModalButton
            color={COLORS.PRIMARY}
            onClick={() => btn2.func()}
          >
            {btn2.label}
          </ModalButton>}
        </div>
      </div>
    </StyledModal>
  )
}

export default Modal;